import React from "react";
import {
  handleChange,
  handleChangeNameValue,
  handleChangeNumeral,
} from "../../../helpers/handleFormChanges";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonSelect from "../../../components/forms/CommonSelect";
import CommonInputDate from "../../../components/forms/CommonInputDate";
import {
  adicionarDias,
  getProximaDataUtil,
} from "../../../helpers/mesesHelper";
import CommonInput from "../../../components/forms/CommonInput";
import CommonRadioOpcoes from "../../../components/forms/CommonRadioOpcoes";
import CommonInputValor from "../../../components/forms/CommonInputValor";
import PropTypes from "prop-types";
import useTipos from "../../../hooks/common/useTipos";

function SolicitarDemissaoModal({
  isOpen,
  setIsOpen,
  valuesHook,
  solicitarDemissao,
  visualizar,
}) {
  const { values, setValues } = valuesHook;
  const tiposAvisoPrevio = useTipos("tipos_aviso_previo");
  const tiposDemissao = useTipos("tipos_demissao");
  const tiposReducaoAviso = useTipos("tipos_reducao_aviso");

  React.useEffect(() => {
    if (!values?.tipo_demissao || !values.aviso_previo) return;

    let anosCompletos = 0;
    let tipo_demissao = parseInt(values.tipo_demissao);
    let aviso_previo = parseInt(values.aviso_previo);

    if (values.data_admissao) {
      const dataAdmissao = new Date(values.data_admissao);
      const dataAtual = new Date();

      anosCompletos = dataAtual.getFullYear() - dataAdmissao.getFullYear();

      const mesAdmissao = dataAdmissao.getMonth();
      const diaAdmissao = dataAdmissao.getDate();
      const mesAtual = dataAtual.getMonth();
      const diaAtual = dataAtual.getDate();

      if (
        mesAtual < mesAdmissao ||
        (mesAtual === mesAdmissao && diaAtual < diaAdmissao)
      ) {
        anosCompletos--;
      }

      anosCompletos = Math.max(0, anosCompletos);
    }

    const updates = {};

    if (aviso_previo === 3) updates.dias_aviso = 0;
    else if ([1, 2].includes(aviso_previo) && tipo_demissao === 3)
      updates.dias_aviso = 30;
    else updates.dias_aviso = 30 + 3 * anosCompletos;

    if (values.data_aviso && parseInt(values.aviso_previo) === 2) {
      updates.data_demissao = adicionarDias(
        updates.dias_aviso,
        new Date(values.data_aviso)
      );
    } else if (values.data_aviso && parseInt(values.aviso_previo) === 1) {
      updates.data_demissao = values.data_aviso
    }

    setValues((prevValues) => ({
      ...prevValues,
      ...updates,
    }));
  }, [
    values.aviso_previo,
    values.data_aviso,
    values.data_admissao,
    values.tipo_demissao,
    setValues,
  ]);

  return (
    <CommonModal
      title={visualizar ? "Demissão" : "Solicitar demissão"}
      is_open_modal={isOpen}
      set_is_open_modal={setIsOpen}
      size="md"
      buttons={
        visualizar ? null : (
          <CommonButton
            key={`solicitar-demissao`}
            onClick={solicitarDemissao}
            color="success"
          >
            Confirmar solicitação
          </CommonButton>
        )
      }
    >
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonSelect
            id="tipo_demissao"
            label="Tipo de demissão"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.tipo_demissao}
            data={tiposDemissao.map((demissao) => ({
              text: demissao.valor,
              id: demissao.chave,
            }))}
            disabled={visualizar}
            required
          />
        </div>
        <div className="col-md-6 mb-3">
          <CommonSelect
            id="aviso_previo"
            label="Aviso prévio"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.aviso_previo}
            data={tiposAvisoPrevio.map((avisoPrevio) => ({
              text: avisoPrevio.valor,
              id: avisoPrevio.chave,
            }))}
            disabled={visualizar}
            required
          />
        </div>
      </div>
      {values?.aviso_previo && parseInt(values?.aviso_previo) !== 3 ? (
        <div className="row">
          <div className="col-md-6 mb-3">
            <CommonInputDate
              id="data_aviso"
              onChange={(e) => handleChange(e, values, setValues)}
              value={values.data_aviso}
              label="Data do aviso"
              min={adicionarDias(-30)}
              max={adicionarDias(30)}
              disabled={visualizar}
            />
          </div>
          <div className="col-md-6 mb-3">
            <CommonInput
              id="dias_aviso"
              onChange={(e) => handleChange(e, values, setValues)}
              value={values.dias_aviso}
              label="Dias de aviso indenizado"
              disabled
            />
          </div>
        </div>
      ) : null}
      <div className="row">
        {values?.aviso_previo &&
        parseInt(values?.aviso_previo) === 2 &&
        values?.tipo_demissao &&
        parseInt(values?.tipo_demissao) !== 3 ? (
          <div className="col-md-6 mb-3">
            <CommonSelect
              id="reducao_aviso"
              label="Redução do aviso"
              onChange={(e) => handleChange(e, values, setValues)}
              value={values.reducao_aviso}
              data={tiposReducaoAviso.map((reducaoAviso) => ({
                text: reducaoAviso.valor,
                id: reducaoAviso.chave,
              }))}
              disabled={visualizar}
              required
            />
          </div>
        ) : null}
        <div className="col-md-6 mb-3">
          <CommonInputDate
            id="data_demissao"
            onChange={(e) => handleChange(e, values, setValues)}
            value={values.data_demissao}
            min={getProximaDataUtil(adicionarDias(1))}
            label="Data da demissão"
            disabled={visualizar || parseInt(values?.aviso_previo) !== 3}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonRadioOpcoes
            label="Inserir faltas?"
            id="inserir_faltas"
            upValue={!values.inserir_faltas}
            lowValue={values.inserir_faltas}
            upOnChange={(e) =>
              handleChangeNameValue(
                "inserir_faltas",
                !e.target.checked,
                values,
                setValues
              )
            }
            lowOnChange={(e) =>
              handleChangeNameValue(
                "inserir_faltas",
                e.target.checked,
                values,
                setValues
              )
            }
            upText="Não"
            lowText="Sim"
            disabled={visualizar}
          />
        </div>
        <div className="col-md-6 mb-3">
          {values?.inserir_faltas && (
            <CommonInput
              id="faltas"
              onChange={(e) => handleChangeNumeral(e, values, setValues)}
              value={values.faltas}
              label="Informe quantos dias:"
              disabled={visualizar}
              required
            />
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonRadioOpcoes
            label="Possui horas extras?"
            id="possui_horas_extras"
            upValue={!values.possui_horas_extras}
            lowValue={values.possui_horas_extras}
            upOnChange={(e) =>
              handleChangeNameValue(
                "possui_horas_extras",
                !e.target.checked,
                values,
                setValues
              )
            }
            lowOnChange={(e) =>
              handleChangeNameValue(
                "possui_horas_extras",
                e.target.checked,
                values,
                setValues
              )
            }
            upText="Não"
            lowText="Sim"
            disabled={visualizar}
          />
        </div>
        {values?.possui_horas_extras && (
          <div className="col-md-6 mb-3">
            <CommonInput
              id="horas_extras"
              onChange={(e) => handleChangeNumeral(e, values, setValues)}
              value={values.horas_extras}
              label="Informe quantas horas extras:"
              disabled={visualizar}
              required
            />
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonRadioOpcoes
            label="Outros descontos?"
            id="descontos"
            upValue={!values.descontos}
            lowValue={values.descontos}
            upOnChange={(e) =>
              handleChangeNameValue(
                "descontos",
                !e.target.checked,
                values,
                setValues
              )
            }
            lowOnChange={(e) =>
              handleChangeNameValue(
                "descontos",
                e.target.checked,
                values,
                setValues
              )
            }
            upText="Não"
            lowText="Sim"
            disabled={visualizar}
          />
        </div>
        {values?.descontos && (
          <div className="col-md-6 mb-3">
            <CommonInputValor
              label="Informe os descontos:"
              id="outros_descontos"
              value={values.outros_descontos}
              onChange={(e) => {
                handleChangeNameValue(
                  "outros_descontos",
                  e.target.value,
                  values,
                  setValues
                );
              }}
              disabled={visualizar}
              tag={null}
              required
            />
          </div>
        )}
      </div>
    </CommonModal>
  );
}

SolicitarDemissaoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  solicitarDemissao: PropTypes.func.isRequired,
  visualizar: PropTypes.bool.isRequired,
};

export default SolicitarDemissaoModal;
